import { useEffect } from "react";
import socket from "../websocket";
import { useSelector } from "react-redux";

export default function useAuthObserver() {
  const is_auth = useSelector(({ authentication }) => authentication.isAuth);
  useEffect(() => {
    socket.reconnect();
  }, [is_auth]);
}
